import OrderInboxDetails from '@/dealers/components/Inbox/OrderInboxDetails'
import RFQInboxDetails from '@/dealers/components/Inbox/RFQInboxDetails'
import { DetailsForConversationProps } from '@/dealers/components/Inbox/types'

const InboxDetails = (props: DetailsForConversationProps) => {
  // For dealers, an external-order conversation resolves to a null `source` (the RFQ is
  // hidden from Sales Hub Pro). The backend now keeps those out of the inbox, but a single
  // null-source conversation rendering here used to white-screen the whole inbox, so guard
  // it directly too. See GEA-3513.
  const { source } = props.conversation

  if (!source) return null

  return source.type === 'request' ? (
    <RFQInboxDetails {...props} />
  ) : source.type === 'store_order' ? (
    <OrderInboxDetails {...props} />
  ) : null
}

export default InboxDetails
